import { LayoutHOC } from "base/ui/layout/layout";
import { createProductionTime } from "./productionTime";



export const createProductionTimePage = (layoutHOC: LayoutHOC) => {
    return layoutHOC(createProductionTime());
};